<template>
  <el-container class='box'>
    <div class="headerCom">
      <publicBreadCrumb  :breadList="breadList"/> 
    </div>
    <el-main class="listTabel">
      <el-table :data="tableData" :header-cell-style="{
			  background:'#FAFAFA',
			  fontWeight: 'bold',
			  color: '#333333',
			  fontSize:'14px'
			}">
        <el-table-column prop="projectName" label="分享项目" width="100px">
        </el-table-column>
        <el-table-column align="center" prop="publicityText" label="宣传文案" min-width="300px" >
          <template slot-scope="scope">
            <el-tooltip :content="scope.row.publicityText"
              :disabled="scope.row.publicityText&&scope.row.publicityText.length>6?false:true" placement="top">
              <span class="tooltipWidth">{{ scope.row.publicityText | filterValgang }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="publicityPictureUrl" label="宣传图片" min-width="100px">
          <template slot-scope="scope">
            <img style="width:50px;height:50px" :src="ossBaseUrl+scope.row.publicityPictureUrl" alt="">
          </template>
        </el-table-column>
        
        <el-table-column prop="updateUserName" label="操作人">
        </el-table-column>
        
        <el-table-column align="center" fixed="right" width="180" label="操作">
          <template slot-scope="scope">
            
              <el-button @click="onEditeClick(scope.row)" type="text" size="small">
                编辑
              </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page.sync="searchParams.current" :page-size="searchParams.size"
        layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </el-main>
    <el-dialog title="编辑" :visible.sync="dialogFormVisible" width="600px">
      <el-form :model="form" ref="form" label-width="120px" :rules="rules">
        <el-form-item label="分享页面:" prop="projectName">
          {{form.projectName}}
        </el-form-item>
        <el-form-item label="宣传文案:" prop="publicityText">
          <el-input v-model="form.publicityText" maxlength="27" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="宣传图片:" prop="publicityPictureUrlRes">
          <BaseUploadFile
            :multiple="false"
            :fileSize="6"
            :isShowTip="false"
            :cropWidth="100"
            :cropHeight="100"
            :size="100"
            :height="100"
            :action="VUE_APP_BASE_URL1"
            
            :beforeRemove="handleMessage3beforeRemove"
            :responseFn="handleMessageResponse3"
            :data="{ path: 'dsicm-doctor' }"
            v-model="form.publicityPictureUrlRes"
          >
          </BaseUploadFile>
          <p style="font-size: 10px;font-weight: 400;color: #999999;">* 请上传至少100*100px的正方形图片，最大1M的png、jpg、jpeg</p>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogFormVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="editSure">确 定</el-button>
      </div>
    </el-dialog>
  </el-container>
</template>

<script>
import {
  sharePageById,
  sharePage,
  sharePageByIdPut,
} from "./api";

export default {
  components:{},
  props:{},
  data(){
    return {
      breadList:[{name:'运营管理'},{name:'小程序分享'}],
      rules: {
          projectName:[{ required: true, message: '此项为必填项', trigger: ['change', 'blur']}],
          publicityText:[
            { required: true, message: '此项为必填项', trigger: ['change', 'blur']},
            { min: 1, max: 30, message: '长度在 1 到 27个字符', trigger: 'blur' }
          ],
          publicityPictureUrlRes:[{ required: true, message: '此项为必填项', trigger: ['change', 'blur']}],
      },
      ossBaseUrl: process.env.VUE_APP_OSS_URL,
      dialogFormVisible:false,
      form:{
        publicityPictureUrlRes:'',
        publicityPictureUrl:'',
      },
      searchParams:{
        size:10,
        current:1
      },
      tableData:[],
      total:0,
      VUE_APP_BASE_URL1: "",
    }
  },
  watch:{},
  computed:{},
  methods:{ 
    getList(){
      sharePage(this.searchParams).then((result) => {
        if (result.code !== 0) {
          return;
        }
        this.tableData = result.data.records;
        this.total = result.data.total;
      }).catch((err) => {
        
      });
    },
    editSure(){
      this.$refs['form'].validate((valid) => {
        if(valid){
          if(!this.form.publicityText.trim()){
            return this.$message.info("请按要求填写");
          }
          sharePageByIdPut(this.form).then((result) => {
            this.getList()
            this.dialogFormVisible = false
          }).catch((err) => {
            
          });
        }
      })
    },
    onEditeClick(data){
      sharePageById(data.id).then((res) => {
        this.form = res.data;
        this.form.publicityPictureUrlRes = this.ossBaseUrl+res.data.publicityPictureUrl;
        this.dialogFormVisible = true;
      }).catch((err) => {
        
      });
    },
    handleSizeChange(value) {
      this.searchParams.size = value;
      this.getList();
    },
    handleCurrentChange(value) {
      this.searchParams.current = value;
      this.getList();
    },
    handleMessageResponse3(res) {
      if (res.code !== 0) {
        return;
      }
      this.form.publicityPictureUrl = res.data
      this.form.publicityPictureUrlRes=`${this.ossBaseUrl}${res.data}`
      this.$set(this.form,'publicityPictureUrlRes',`${this.ossBaseUrl}${res.data}`)
      this.$forceUpdate();
      return `${this.ossBaseUrl}${res.data}`;
    },
    handleMessage3beforeRemove() {
      
      
      this.$nextTick(()=>{
        this.form.publicityPictureUrl = ''
        this.$set(this.form,'publicityPictureUrlRes','');
        this.$forceUpdate();
      })
      
       
    },
  },
  created(){
    this.VUE_APP_BASE_URL1 = "/api/dsicm-contact-platform/feign/file/upload";
    this.getList()
  },
  mounted(){}
}
</script>
<style lang="less" scoped>
.box {
  height: 100%;
  display: flex;
  flex-direction: column;
}

/deep/.el-pagination {
  text-align: right;
  margin-top: 30px;
  margin-right: 30px;
  padding-bottom: 20px;
}
</style>